import { Box, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import LogoMark from './LogoMark';
export default function Logo({ tagline = false }) {
  const site = useSelector((state) => state.siteInfo);
  const name = site.system_name || '模型网关';
  if (site.logo) return <Box component="img" src={site.logo} alt={name} sx={{ height: 34, maxWidth: 174, objectFit: 'contain' }} />;
  return (
    <Stack direction="row" alignItems="center" gap={1.25}>
      <LogoMark />
      <Box>
        <Typography sx={{ fontSize: 18, fontWeight: 750, letterSpacing: '.02em', lineHeight: 1.2 }}>{name}</Typography>
        {tagline && <Typography sx={{ fontSize: 9, letterSpacing: '1.6px', color: 'text.secondary', mt: 0.5 }}>AI GATEWAY</Typography>}
      </Box>
    </Stack>
  );
}
